<template>
	<div class="cr-contianer">
		<div class="title">关联业务</div>
		<div style="height: 100%;position: relative;">
			<div class="cr-body-side">
				<div 
					v-for="(item, index) in leftSides" 
					:key="index"
					:class="leftType===item.type? 'side-item-select' : 'side-item-default'" 
					@click="sideClick(item)"
					class="side-item">{{item.name}}</div>
			</div>
			<div style="padding-left:150px">
				<crm-relative-all-table 
					v-for="(item, index) in leftSides" 
					:key="index" 
					:ref="'crm'+item.type"
					:show="show && item.type == leftType" 
					v-show="item.type == leftType" 
					:radio="radio"
					:crmType="item.type" 
					:selectedData="currentSelectedData" 
					:action="action"
					@changeCheckout="checkCrmTypeInfos"></crm-relative-all-table>
			</div>
		</div>
		<div class="handle-bar">
			<el-button @click.native="closeView">取消</el-button>
			<el-button @click.native="confirmClick" type="primary">确定</el-button>
		</div>
	</div>
</template>

<script>
	import { objDeepCopy } from '@/utils'
	import CrmRelativeAllTable from './CrmRelativeAllTable'
	export default {
		components: {
			CrmRelativeAllTable
		},
		data() {
			return {
				leftType: 'customer',
				leftSides: [],
				/** 各类型选择的值 */
				currentSelectedData: {}
			}
		},
		props: {
			/** 多选框 只能选一个 */
			radio: {
				type: Boolean,
				default: true
			},
			
			/** 需要展示哪些类型 默认关键字数组 */
			showTypes: {
				type: Array,
				default: () => {
					return [
						'customer',
						'lawcase',
						'contract'
					]
				}
			},
			/** 已选信息 */
			selectedData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			/** true 的时候 发请求 */
			show: {
				type: Boolean,
				default: true
			},
			/**
			 * default 默认  condition 固定条件筛选
			 * relative: 相关 添加
			 */
			action: {
				type: Object,
				default: () => {
					return {
						type: 'default',
						data: {}
					}
				}
			}
		},
		watch: {
			selectedData: function(data) {
				this.currentSelectedData = objDeepCopy(data)
			},
			// 刷新标记
			show(val) {
				if (val) {
					this.currentSelectedData = objDeepCopy(this.selectedData)
				}
			}
		},
		mounted() {
			var leftItems = {
				customer: {
					name: '客户',
					type: 'customer'
				},
				lawcase: {
					name: '案件',
					type: 'lawcase'
				},
				contract: {
					name: '顾问',
					type: 'contract'
				}
			}
			for (let index = 0; index < this.showTypes.length; index++) {
				const element = this.showTypes[index]
				this.leftSides.push(leftItems[element])
			}
			this.currentSelectedData = objDeepCopy(this.selectedData)
		},
		methods: {
			sideClick(item) {
				this.leftType = item.type
			},

			// 关闭操作
			closeView() {
				this.$emit('close')
			},

			// 确定选择
			confirmClick() {
				this.$emit('changeCheckout', {
					data: this.currentSelectedData
				})

				this.$emit('close')
			},
			
			checkCrmTypeInfos(data) {
				this.currentSelectedData[data.type] = data.data
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.cr-contianer {
		height: 450px;
		position: relative;
		padding: 50px 0 50px 0;
	}

	.title {
		padding: 0 20px;
		font-size: 16px;
		line-height: 50px;
		height: 50px;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		z-index: 3;
		border-bottom: 1px solid #eee;
	}

	.handle-bar {
		height: 50px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 2;

		button {
			float: right;
			margin-top: 10px;
			margin-right: 10px;
		}
	}

	.cr-body-side {
		flex-shrink: 0;
		z-index: 3;
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 150px;
		font-size: 12px;
		background-color: white;
		height: 100%;
		border-right: 1px solid #eee;

		.side-item {
			height: 35px;
			line-height: 35px;
			padding: 0 20px;
			cursor: pointer;
		}
	}

	.side-item-default {
		color: #333;
	}

	.side-item-select {
		color: #409eff;
		background-color: #ecf5ff;
	}
</style>